module.exports = __webpack_public_path__ + "static/media/logo2.995d52d9.svg";